import { render, staticRenderFns } from "./SmartTableComp.vue?vue&type=template&id=01633469&scoped=true"
import script from "./SmartTableComp.vue?vue&type=script&lang=js"
export * from "./SmartTableComp.vue?vue&type=script&lang=js"
import style0 from "./SmartTableComp.vue?vue&type=style&index=0&id=01633469&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01633469",
  null
  
)

export default component.exports